<div #trigger="cdkOverlayOrigin" cdkOverlayOrigin class="dropdown-trigger">
  <app-button
    (click)="toggleDropdown()"
    [variant]="variant()"
    [size]="size()">
    @if (!dots() || dots() === 'no') {
      {{ buttonTitle() }}
    }
    @if (dots() === 'yes') {
      <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 18.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z" />
      </svg>
    }
  </app-button>
</div>
<ng-template #dropdownTemplate>
  <div class="dropdown-panel" @slideInUpOnEnter @fadeInOnEnter>
    <ng-content></ng-content>
  </div>
</ng-template>
